// (c) chaehongee. Confidential and proprietary.

import { http, buildApiUrl } from './http'
import type { UsageDashboardResponse } from 'models-ts/usage'

/**
 * Get aggregated usage analytics for the current user over a rolling period.
 *
 * @param days Number of trailing calendar days to include (1-90)
 */
export async function getUsageDashboard(
    days: number
): Promise<UsageDashboardResponse> {
    return http<UsageDashboardResponse>(
        buildApiUrl(`/user/usage?days=${days}`),
        { method: 'GET' }
    )
}
